import { Selection } from '../types';

export function setInputSelection(
  input: HTMLInputElement,
  start: number,
  end?: number,
): void {
  if (end === undefined) {
    end = start;
  }

  if (input.selectionStart === null) {
    return;
  }

  input.setSelectionRange(start, end);
}

export function getInputSelection(input: HTMLInputElement | null): Selection {
  if (!input) {
    return { start: null, end: null, length: 0 };
  }

  const start = input.selectionStart;
  const end = input.selectionEnd;

  return {
    start,
    end,
    length: (end ?? 0) - (start ?? 0),
  };
}

export function isInputFocused(input: HTMLInputElement | null): boolean {
  if (!input) {
    return false;
  }

  // WARNING: Исправлено для VK HR Tek - использование getRootNode() вместо ownerDocument
  // для корректной работы с Shadow DOM
  const rootNode = input.getRootNode();
  const activeElement =
    'activeElement' in rootNode ? rootNode.activeElement : null;

  return activeElement === input;
}
